import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles, TextField, Button, Typography, IconButton } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';

import { oper as v_oper, edu as v_edu, basic, Values } from '../request/values';
import ToastStr from '../request/toastStr';
import { COLORS } from '../shared/Theme';
import DialogConfirm from '../components/Dialog';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	paper: {
		// marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
		maxWidth: 520,
		margin: '0 auto',
		paddingBottom: theme.spacing(10),
		[theme.breakpoints.up('md')]: {
			paddingTop: '0',
		},
	},
	title: {
		width: '100%',
		alignItems: 'left',
		'& img': {
			width: '45vw',
		},
		[theme.breakpoints.up('md')]: {
			width: '80%',
			'& img': {
				width: '80%',
			},
		},
	},
	form: {
		marginTop: '2vh',
		width: '100%', // Fix IE 11 issue.
	},
	stack: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: theme.spacing(1),
	},
	submit: {
		width: '60%',
		//height: 60,
		padding: '15px',
		marginBottom: theme.spacing(2),
		borderRadius: '12px',
		boxShadow: '6px 3px 6px 0 rgba(37, 31, 31, 0.16)',
		border: 'solid 0.5px #cfd4d9',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		'&:hover': {
			backgroundColor: `${COLORS.WATER_BLUE}`,
		},
	},
	desc: {
		marginTop: '2.5vh',
		marginBottom: '1vh',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		color: `${COLORS.WATER_BLUE}`,
		[theme.breakpoints.up('md')]: {
			fontSize: '1.75rem',
		},
	},
	iconButtonPadding: {
		padding: '4px 8px',
		borderRadius: 8,
		marginBottom: '1vh',
		[theme.breakpoints.up('md')]: {
			marginLeft: '43px',
		},
	},
	selectField: {
		width: '100%',
		maxWidth: 420,
		marginTop: theme.spacing(1),
	},
	selectRoot: {
		'& .MuiFormLabel-root, & .MuiSelect-root': {
			[theme.breakpoints.down('md')]: {
				fontSize: '1rem',
			},
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 12,
			'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
				borderColor: COLORS.WATER_BLUE,
				borderWidth: 2,
			},
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#cfd4d9',
		},
	},
	selectLabel: {
		padding: '0 4px',
	},
	menuPaper: {
		borderRadius: 12,
		boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
		marginTop: 8,
	},
	menuItem: {
		...theme.typography.body1,
		padding: theme.spacing(1.25, 1.5),
		'&:not(:last-child)': {
			borderBottom: '1px solid #f1f3f5',
		},
	},
	qrCode: {
		width: '130px',
		height: '130px',
		[theme.breakpoints.up('md')]: {
			width: '180px',
			height: '180px',
		},
	},
	logoutText: {
		margin: '0px 0px 0px 10px',
		fontSize: '14px',
		fontWeight: 'bold',
	},
	contentWrap: {
		width: '100%',
		maxWidth: 420,
		margin: '0 auto',
	},
	tabWrap: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		gap: theme.spacing(1),
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1.5),
		background: COLORS.LIGHT_GREY,
		borderRadius: 14,
		padding: theme.spacing(1),
	},
	createWrap: {
		width: '100%',
		background: '#F7F7F8',
		borderRadius: 16,
		padding: theme.spacing(1.2, 2),
	},
	tabBtn: {
		flex: 1,
		borderRadius: 12,
		padding: theme.spacing(1.8, 2),
		border: '1px solid transparent',
		background: 'transparent',
		cursor: 'pointer',
	},
	tabBtnActive: {
		background: COLORS.WHITE,
		borderColor: COLORS.LIGHT_BLUE_GREY,
		boxShadow: '0 4px 14px rgba(0,0,0,0.1)',
	},
	tabText: {
		fontSize: '0.95rem',
		fontFamily: 'NanumR',
		fontWeight: 'bold',
		color: COLORS.DOWN,
	},
	tabTextActive: {
		color: COLORS.WATER_BLUE,
	},
	primaryBtn: {
		width: '100%',
	},
	createClassPanel: {
		width: '100%',
		borderRadius: 12,
		padding: theme.spacing(1, 1.25),
	},
	classNameLabel: {
		width: '100%',
		marginTop: 0,
		fontSize: '0.9rem',
		color: COLORS.CHARCOAL_GREY,
		fontFamily: 'NanumR',
		fontWeight: 'bold',
	},
	classNameField: {
		width: '100%',
		marginTop: 3,
		'& .MuiOutlinedInput-root': {
			borderRadius: 12,
			background: COLORS.WHITE,
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: COLORS.WATER_BLUE,
			borderWidth: 2,
		},
		'& .MuiOutlinedInput-input': {
			paddingTop: 10,
			paddingBottom: 11,
			'&::placeholder': {
				fontSize: '1rem',
			},
		},
	},
	classNameText: {
		width: '100%',
		fontSize: '1.1rem',
		color: COLORS.CHARCOAL_GREY,
		fontFamily: 'NanumR',
		fontWeight: 'bold',
		paddingTop: theme.spacing(0.5),
		paddingBottom: theme.spacing(1),
		textAlign: 'center',
	},
	codeTextLarge: {
		fontSize: '1.7rem',
		letterSpacing: '0.22em',
		paddingLeft: '0.22em',
		fontWeight: 'bold',
		color: COLORS.WATER_BLUE,
		fontFamily: 'NanumR',
	},
	qrWrap: {
		background: COLORS.WHITE,
		borderRadius: 12,
		padding: theme.spacing(0.9),
		border: '1px solid #f1f3f5',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: theme.spacing(1),
	},
	testPanel: {
		width: '100%',
		background: 'transparent',
		borderRadius: 16,
		padding: theme.spacing(1, 1.25),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: theme.spacing(1.1),
	},
	testNotice: {
		width: '100%',
		borderRadius: 12,
		padding: theme.spacing(1.5, 1.25),
		background: '#FFF5F5',
		border: '1px dashed #FCA5A5',
		textAlign: 'center',
	},
	testNoticeTitle: {
		fontSize: '0.95rem',
		fontFamily: 'NanumR',
		fontWeight: 'bold',
		color: '#DC2626',
		marginBottom: theme.spacing(0.5),
	},
	testNoticeDesc: {
		fontSize: '0.85rem',
		fontFamily: 'NanumR',
		fontWeight: 'bold',
		color: '#EF4444',
		lineHeight: 1.35,
	},
	primaryBtnText: {
		color: COLORS.WHITE,
		fontFamily: 'NanumR',
		fontWeight: 'bold',
		fontSize: '1.2rem',
	},
	lastBtnText: {
		color: COLORS.WHITE,
		fontFamily: 'NanumR',
		fontWeight: 'bold',
		fontSize: '1rem',
	},
	underLink: {
		marginTop: theme.spacing(0.5),
		background: 'transparent',
		border: 'none',
		padding: 0,
		cursor: 'pointer',
		fontSize: '0.9rem',
		fontFamily: 'NanumR',
		fontWeight: 'bold',
		color: COLORS.GREY,
		textDecoration: 'underline',
	},
	lastSection: {
		width: '100%',
		maxWidth: 420,
		marginTop: theme.spacing(2),
	},
	lastTitle: {
		fontSize: '1em',
		fontFamily: 'NanumR',
		fontWeight: 'bold',
		color: COLORS.CHARCOAL_GREY,
		marginBottom: theme.spacing(1),
	},
	lastCard: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: theme.spacing(1.5),
		background: '#F7F7F8',
		borderRadius: 12,
		padding: theme.spacing(1.5, 2),
	},
	lastLeft: {
		flex: 1,
		minWidth: 0,
	},
	lastName: {
		fontSize: '0.9rem',
		fontFamily: 'NanumR',
		fontWeight: 'bold',
		color: COLORS.CHARCOAL_GREY,
	},
	lastDate: {
		marginTop: theme.spacing(0.25),
		fontSize: '0.85rem',
		fontFamily: 'NanumR',
		color: COLORS.DOWN,
	},
	lastContinueBtn: {
		width: 'auto',
		padding: '10px 14px',
		marginBottom: 0,
	},
}));

const OperCreateClass: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('oper');
	const { member, setMember, deleteMember } = props;

	const [mode, setMode] = useState<'actual' | 'test'>('actual');
	const [classCode, setClassCode] = useState<string>('');
	const [classStartTime, setClassStartTime] = useState<string | null>(null);
	const [classEndTime, setClassEndTime] = useState<string | null>(null);
	const [classStatus, setClassStatus] = useState<string | null>(null);
	const [className, setClassName] = useState<string>('');
	const [classNameInput, setClassNameInput] = useState<string>('');
	const [testClassCreated, setTestClassCreated] = useState<boolean>(false);
	const [testClassName, setTestClassName] = useState<string>('');
	const [logoutDialog, setLogoutDialog] = useState<boolean>(false);
	let history = useHistory();
	const { enqueueSnackbar } = useSnackbar();
	const [lastEducation, setLastEducation] = useState<{
		class_code: string;
		class_name: string | null;
		reg_date: string;
		class_version?: string;
	} | null>(null);
	const [confirmPopup, setConfirmPopup] = useState<{ type: null | 'newClass' | 'resumeLastEducation' | 'rankingOnly' }>({ type: null });
	const autoResetFiredRef = useRef(false);

	const HOUR_MS = 60 * 60 * 1000;

	const safeDate = (value: any): Date | null => {
		if (!value) return null;
		const d = new Date(typeof value === 'string' ? value.replace(' ', 'T') + 'Z' : value);
		if (Number.isNaN(d.getTime())) return null;
		return d;
	};
	const now = new Date();
	const startTime = safeDate(classStartTime);
	const endTime = safeDate(classEndTime);

	const expireByStart72h = !!startTime && now.getTime() >= startTime.getTime() + 72 * HOUR_MS;
	const expireByFinish = classStatus === 'finish';
	const expireByEndDate = !!endTime && now.getTime() >= endTime.getTime();
	// finish이거나 start+72h이거나 now ≥ end_date이면 만료
	const isExpired = mode === 'actual' && !!classCode && classCode !== '12345' && (expireByStart72h || expireByFinish || expireByEndDate);

	const hasActiveCode = mode === 'actual' && !!classCode && classCode !== '12345' && !isExpired;
	const isBeforeStart = hasActiveCode && !startTime;
	const isInProgress = hasActiveCode && !!startTime;

	const safeClassName = className.trim();

	let pageTitle = t('OperCreateClass.createClassCode');
	if (mode === 'actual') {
		if (!isExpired) {
			if (isBeforeStart) pageTitle = t('OperCreateClass.startBefore');
			if (isInProgress) pageTitle = t('OperCreateClass.inProgress');
		}
	}

	const showActualCreateForm = mode === 'actual' && !hasActiveCode;
	const logout = () => {
		deleteMember();
		window.location.href = 'https://educator.youstarter.co.kr/educator/login?logout=true';
	};

	const handleLogoutOpen = () => {
		setLogoutDialog(true);
	};

	const handleClose = () => {
		setLogoutDialog((prevState) => !prevState);
	};

	// 클래스 접속
	const handleClassEnter = () => {
		history.push({
			pathname: '/operation/company/list',
		});
	};

	const handleTestClassCreate = () => {
		if (!testClassName.trim()) {
			enqueueSnackbar(t('OperCreateClass.enterClassName'), { variant: 'warning' });
			return;
		}
		setTestClassCreated(true);
	};

	// 클래스 코드 생성
	const handleClassCodeCreate = () => {
		const className = classNameInput.trim();
		if (!className) {
			enqueueSnackbar(t('OperCreateClass.enterClassName'), { variant: 'warning' });
			return;
		}
		axios({
			method: 'POST',
			withCredentials: true,
			data: {
				operId: member.id,
				className: className,
			},
			url: SERVER + v_oper.oper + v_oper.new_class,
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code !== Values.SUCCESS_CODE || !data.class_code) {
					enqueueSnackbar(ToastStr.CLASS_CREATE_FAIL_STR, {
						variant: 'warning',
					});
					return;
				}
				console.log('data? ', data);
				if (member) {
					setMember({
						...member,
						classCode: data.class_code,
						classVersion: data.class_version,
					});
				}
				enqueueSnackbar(ToastStr.CLASS_CREATE_SUCCESS_STR, {
					variant: 'success',
				});
				setClassCode(data.class_code);
				setClassStartTime(null);
				setClassEndTime(null);
				setClassStatus(null);
				setClassName(className);
				getClassCodeInfo(data.class_code);
			})
			.catch(() => {
				enqueueSnackbar(ToastStr.CLASS_CREATE_FAIL_STR, {
					variant: 'warning',
				});
			});
	};

	// 클래스 코드 정보 조회
	const getClassCodeInfo = async (classCode: string) => {
		const response = await axios.get(SERVER + v_oper.oper + v_oper.class_info, { params: { classCode: classCode } });
		if (response.data.code == Values.SUCCESS_CODE) {
			setClassCode(response.data.classInfo[0].class_code);
			setClassStartTime(response.data.classInfo[0].start_date ?? null);
			setClassEndTime(response.data.classInfo[0].end_date ?? null);
			setClassStatus(response.data.classInfo[0].class_status ?? null);
			setClassName((response.data.classInfo[0].class_name ?? '').toString());
		} else {
			setClassCode('');
			setClassStartTime(null);
			setClassEndTime(null);
			setClassStatus(null);
			setClassName('');
		}
	};

	// 클래스 코드 새로 생성하기 (초기화)
	const handleResetOperatorClass = () => {
		axios({
			method: 'POST',
			withCredentials: true,
			data: {
				operId: member.id,
			},
			url: SERVER + v_oper.oper + v_oper.delete_class,
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code === Values.SUCCESS_CODE) {
					if (member) {
						setMember({ ...member, classCode: null });
					}
					setMode('actual');
					setClassCode('');
					setClassStartTime(null);
					setClassEndTime(null);
					setClassStatus(null);
					setClassName('');
					setClassNameInput('');
					fetchLastEducation();
				} else {
					enqueueSnackbar(ToastStr.CLASS_CREATE_FAIL_STR, { variant: 'warning' });
				}
			})
			.catch(() => {
				enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: 'error' });
			});
	};

	// 이전 강의 정보 조회
	const fetchLastEducation = () => {
		if (!member?.id) return;
		axios
			.get(SERVER + v_edu.path + v_edu.class_last_education, {
				params: { operatorEmail: member.id },
				withCredentials: true,
			})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code === Values.SUCCESS_CODE && data.detail) {
					setLastEducation(data.detail);
				} else {
					setLastEducation(null);
				}
			})
			.catch(() => {
				setLastEducation(null);
			});
	};

	// 이전 강의 or 테스트 클래스 접속 (toRanking: 랭킹만 보기)
	const handleEnterEducation = (classCode: string, toRanking = false) => {
		if (!classCode || !member?.id) return;

		axios({
			method: 'POST',
			data: {
				email: member.id,
				classCode,
			},
			withCredentials: true,
			url: SERVER + v_oper.oper + v_oper.class_enter,
		})
			.then((res) => res.data)
			.then(async (data: any) => {
				if (data.code === Values.SUCCESS_CODE) {
					setMember({
						...member,
						classCode,
						classVersion: data.class_version,
					});
					if (toRanking) {
						history.push({ pathname: '/operation/OpenRanking', state: { code: classCode } });
						return;
					}
					if (classCode === '12345') {
						setMode('test');
						setClassCode('12345');
						enqueueSnackbar(t('OperCreateClass.testClassEnterSuccess'), { variant: 'success' });
					} else {
						enqueueSnackbar(t('OperCreateClass.lastEducationEnterSuccess'), { variant: 'success' });
					}
					handleClassEnter();
				} else if (data.code === Values.CLASS_CODE_NOT_FOUND_CODE) {
					enqueueSnackbar(ToastStr.CLASS_CODE_NOT_FOUND_STR, { variant: 'warning' });
				} else if (data.code === Values.CLASS_NO_START_CODE) {
					enqueueSnackbar(ToastStr.CLASS_NO_START_STR, { variant: 'warning' });
				} else if (data.code === Values.CLASS_FINISH_CODE) {
					enqueueSnackbar(ToastStr.CLASS_ALREADY_END_STR, { variant: 'warning' });
				} else {
					enqueueSnackbar(ToastStr.CLASS_ENTER_FAIL, { variant: 'error' });
				}
			})
			.catch(() => {
				enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: 'error' });
			});
	};

	const handleLastEducationContinue = () => {
		const code = lastEducation?.class_code ?? '';
		if (!code) return;

		axios({
			method: 'GET',
			withCredentials: true,
			url: SERVER + v_oper.oper + v_oper.class_info,
			params: { classCode: code },
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code == Values.SUCCESS_CODE) {
					const end = safeDate(data.classInfo[0].end_date);
					if (end && Date.now() >= end.getTime() + HOUR_MS) {
						setConfirmPopup({ type: 'rankingOnly' });
						return;
					}
				}
				setConfirmPopup({ type: 'resumeLastEducation' });
			})
			.catch(() => {
				setConfirmPopup({ type: 'resumeLastEducation' });
			});
	};

	// 클래스 코드 초기화
	useEffect(() => {
		if (!isExpired || autoResetFiredRef.current) return;
		autoResetFiredRef.current = true;
		handleResetOperatorClass();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isExpired]);

	// 클래스 코드 정보 조회
	useEffect(() => {
		const code = String(member?.classCode ?? '').trim();
		if (code && code !== '12345') {
			getClassCodeInfo(code);
		} else {
			setClassCode('');
			setClassStartTime(null);
			setClassEndTime(null);
			setClassStatus(null);
			setClassName('');
		}
		fetchLastEducation();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [member?.classCode]);

	return (
		<>
			<div className={classes.paper} data-testid="oper-create-class-dashboard">
				{/* 로그아웃 버튼 */}
				<div style={{ width: '100%' }}>
					<IconButton className={classes.iconButtonPadding} onClick={() => handleLogoutOpen()}>
						<img src="/images/logout.webp" style={{ width: '6vw', maxWidth: '24px' }} />
						<p className={classes.logoutText}>{t('OperCreateClass.logout')}</p>
					</IconButton>
				</div>
				<div className={classes.title}>
					<img src="/images/logo.webp" />
				</div>

				<div style={{ width: '100%', textAlign: 'center', marginTop: '1vh' }}>
					<Typography className={classes.desc}>{pageTitle}</Typography>
				</div>

				<div className={classes.contentWrap}>
					<div className={mode === 'test' || showActualCreateForm ? classes.createWrap : undefined}>
						<div className={classes.tabWrap} role="tablist" aria-label="클래스 모드 선택">
							<button type="button" className={`${classes.tabBtn} ${mode === 'actual' ? classes.tabBtnActive : ''}`} onClick={() => setMode('actual')}>
								<span className={`${classes.tabText} ${mode === 'actual' ? classes.tabTextActive : ''}`}>{t('OperCreateClass.actual')}</span>
							</button>
							<button type="button" className={`${classes.tabBtn} ${mode === 'test' ? classes.tabBtnActive : ''}`} onClick={() => setMode('test')}>
								<span className={`${classes.tabText} ${mode === 'test' ? classes.tabTextActive : ''}`}>{t('OperCreateClass.test')}</span>
							</button>
						</div>

						<div className={classes.form}>
							{mode === 'test' ? (
								<div className={classes.stack} data-testid="oper-create-class-test-form">
									<div className={classes.testPanel}>
										<div className={classes.testNotice}>
											<div className={classes.testNoticeTitle}>{t('OperCreateClass.testNoticeTitle')}</div>
											<div className={classes.testNoticeDesc}>{t('OperCreateClass.testNoticeDesc')}</div>
										</div>

										{!testClassCreated ? (
											<div className={classes.createClassPanel}>
												<div className={classes.classNameLabel}>{t('OperCreateClass.enterClassNameTitle')}</div>
												<TextField
													className={classes.classNameField}
													variant="outlined"
													placeholder={t('OperCreateClass.enterClassNamePlaceholder')}
													value={testClassName}
													onChange={(e) => setTestClassName(e.target.value)}
													inputProps={{ maxLength: 40, 'data-testid': 'oper-test-class-name-input' }}
												/>
												<Button
													fullWidth
													className={`${classes.submit} ${classes.primaryBtn}`}
													onClick={handleTestClassCreate}
													style={{ marginTop: '2vh' }}
													data-testid="oper-test-create-btn"
												>
													<Typography variant="h3" className={classes.primaryBtnText}>
														{t('OperCreateClass.create')}
													</Typography>
												</Button>
											</div>
										) : (
											<>
												<div className={classes.classNameText} data-testid="oper-test-class-name">
													{testClassName}
												</div>

												<div className={classes.codeTextLarge} data-testid="oper-test-class-code">
													12345
												</div>
												<div className={classes.qrWrap}>
													<QRCode className={classes.qrCode} value={`${basic.base_url}/classEnter?classCode=12345`} />
												</div>

												<Button className={`${classes.submit} ${classes.primaryBtn}`} onClick={() => handleEnterEducation('12345')} data-testid="oper-test-enter-btn">
													<Typography variant="h3" className={classes.primaryBtnText}>
														{t('OperCreateClass.enter')}
													</Typography>
												</Button>
											</>
										)}
									</div>
								</div>
							) : showActualCreateForm ? (
								<div className={classes.stack} data-testid="oper-create-class-actual-form">
									<div className={classes.createClassPanel}>
										<div className={classes.classNameLabel}>{t('OperCreateClass.enterClassNameTitle')}</div>
										<TextField
											className={classes.classNameField}
											variant="outlined"
											placeholder={t('OperCreateClass.enterClassNamePlaceholder')}
											value={classNameInput}
											onChange={(e) => setClassNameInput(e.target.value)}
											inputProps={{ maxLength: 40, 'data-testid': 'oper-class-name-input' }}
										/>
										{/* <TextField
											className={`${classes.selectField} ${classes.selectRoot}`}
											//variant="outlined"
											label={t('OperCreateClass.versionSelect')}
											select
											fullWidth
											value={classVersion}
											InputLabelProps={{ shrink: true, className: classes.selectLabel }}
											onChange={(e) => setClassVersion(Number((e.target as HTMLInputElement).value))}
											SelectProps={{
												MenuProps: {
													getContentAnchorEl: null,
													anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
													transformOrigin: { vertical: 'top', horizontal: 'left' },
													classes: { paper: classes.menuPaper },
												},
											}}
											data-testid="oper-create-class-version-select"
										>
											<MenuItem className={classes.menuItem} value={6} data-testid="oper-create-class-version-6">
												{t('OperCreateClass.version6Kit')}
											</MenuItem> */}
										{/* <MenuItem className={classes.menuItem} value={1}>
										3층 교구
									</MenuItem> */}
										{/* </TextField> */}
										<Button
											fullWidth
											className={`${classes.submit} ${classes.primaryBtn}`}
											onClick={handleClassCodeCreate}
											style={{ marginTop: '2vh' }}
											data-testid="oper-create-class-create-btn"
										>
											<Typography variant="h3" className={classes.primaryBtnText}>
												{t('OperCreateClass.create')}
											</Typography>
										</Button>
									</div>
								</div>
							) : (
								<div className={classes.stack} data-testid="oper-create-class-actual-start-form">
									<div className={classes.classNameText} data-testid="oper-create-class-class-name">
										{safeClassName}
									</div>

									<div className={classes.codeTextLarge} data-testid="oper-create-class-code" data-class-code={classCode}>
										{classCode}
									</div>
									<div className={classes.qrWrap}>
										<QRCode className={classes.qrCode} value={`${basic.base_url}/classEnter?classCode=${classCode}`} />
									</div>

									<Button className={`${classes.submit} ${classes.primaryBtn}`} onClick={handleClassEnter} style={{ marginTop: 0 }} data-testid="oper-create-class-enter-btn">
										<Typography variant="h3" className={classes.primaryBtnText}>
											{isBeforeStart ? t('OperCreateClass.enter') : t('OperCreateClass.continue')}
										</Typography>
									</Button>
									<button type="button" className={classes.underLink} onClick={() => setConfirmPopup({ type: 'newClass' })} data-testid="oper-create-class-new-btn">
										{t('OperCreateClass.createNew')}
									</button>
								</div>
							)}
						</div>
					</div>

					{/* 이전 강의 정보 */}
					{mode === 'actual' && showActualCreateForm && lastEducation && (
						<div className={classes.lastSection} data-testid="oper-last-education-section">
							<div className={classes.lastTitle}>{t('OperCreateClass.lastEducationTitle')}</div>
							<div className={classes.lastCard}>
								<div className={classes.lastLeft}>
									<div className={classes.lastName}>{(lastEducation.class_name || '').trim() || t('OperCreateClass.noName')}</div>
									<div className={classes.lastDate}>
										{lastEducation.reg_date ? new Date(lastEducation.reg_date).toLocaleDateString('ko-KR', { month: 'numeric', day: 'numeric' }) : ''}
									</div>
								</div>
								<Button
									className={`${classes.submit} ${classes.lastContinueBtn}`}
									style={{ background: `${COLORS.WATER_BLUE}` }}
									onClick={() => handleLastEducationContinue()}
									data-testid="oper-last-education-continue-btn"
								>
									<Typography className={classes.lastBtnText}>{t('OperCreateClass.continue')}</Typography>
								</Button>
							</div>
						</div>
					)}
				</div>
			</div>

			<DialogConfirm
				open={logoutDialog}
				handleClose={() => handleClose()}
				title={t('OperCreateClass.logout')}
				context={t('OperCreateClass.logoutConfirmTitle')}
				yesText={t('OperCreateClass.yes')}
				noText={t('OperCreateClass.no')}
				yesConfirm={() => logout()}
				noConfirm={() => handleClose()}
			/>

			<DialogConfirm
				open={confirmPopup.type === 'newClass'}
				handleClose={() => setConfirmPopup({ type: null })}
				title={isBeforeStart ? t('OperCreateClass.dialogStartNotStartedTitle') : isInProgress ? t('OperCreateClass.dialogInProgressTitle') : t('OperCreateClass.dialogEndedTitle')}
				context={isBeforeStart ? t('OperCreateClass.dialogStartNotStartedDesc') : t('OperCreateClass.dialogCreateNewDesc')}
				yesText={t('OperCreateClass.yes')}
				noText={t('OperCreateClass.no')}
				yesConfirm={() => {
					setConfirmPopup({ type: null });
					handleResetOperatorClass();
				}}
				noConfirm={() => setConfirmPopup({ type: null })}
			/>

			<DialogConfirm
				open={confirmPopup.type === 'resumeLastEducation'}
				handleClose={() => setConfirmPopup({ type: null })}
				title={t('OperCreateClass.dialogResumeLastEducationTitle')}
				context={t('OperCreateClass.dialogResumeLastEducationDesc')}
				yesText={t('OperCreateClass.yes')}
				noText={t('OperCreateClass.no')}
				yesConfirm={() => {
					setConfirmPopup({ type: null });
					handleEnterEducation(lastEducation?.class_code ?? '');
				}}
				noConfirm={() => setConfirmPopup({ type: null })}
			/>

			<DialogConfirm
				open={confirmPopup.type === 'rankingOnly'}
				handleClose={() => setConfirmPopup({ type: null })}
				title={t('OperCreateClass.dialogRankingOnlyTitle')}
				context={t('OperCreateClass.dialogRankingOnlyDesc')}
				yesText={t('OperCreateClass.dialogRankingOnlyYes')}
				noText={t('OperCreateClass.no')}
				yesConfirm={() => {
					setConfirmPopup({ type: null });
					handleEnterEducation(lastEducation?.class_code ?? '', true);
				}}
				noConfirm={() => setConfirmPopup({ type: null })}
			/>
		</>
	);
};

export default OperCreateClass;
